// extracted by mini-css-extract-plugin
export default {"cvPage":"CVPage_cvPage__AnBXb"};